import React from "react";
import "../styles/Products.css"
import image from "../assets/images/timer.jpeg"
import { useNavigate } from "react-router-dom";



export default function Products() {
  const products = [
    {
      image: "/img/p1.png",
      name: "CountSync",
      description: "It tracks the exact number of parts produced or processed. It ensures accurate production records and helps verify operator efficiency"
    },
    {
      image: image,
      name: "TimeSync",
      description: "Timer captures precise machine running, idle, and total operating time. It helps manufacturers track productivity, downtime, and improve OEE."
    },
    {
      image: "/img/p2.png",
      name: "StitchSync",
      description: "StitchSync monitors every sewing machine in real time, capturing production counts, runtime, and operator activity with precision."
    },
    {
      image: "/img/p4.png",
      name: "CastSync",
      description: "The device records precise machine runtime, idle time, and production activity while tracking operator performance in real time."
    }
  ];
  const navigate = useNavigate();

  const openProductPage = (name) => {
    navigate(`/products/${name}`);
    window.scrollTo(0, 0);
  };


  return (
    <section className="product-section">
      <button className="product-btn">Our Products</button>

      <h2 className="product-title">
        Powerful <span className="highlight">Industrial Monitoring Products</span>
      </h2>

      <p className="product-subtitle">
        Manage machines, boost productivity and make smarter decisions with our IoT-powered ecosystem.
      </p>

      <div className="product-container">
        {products.map((item, index) => (
          <div className="product-card" key={index}
            onClick={() => openProductPage(item.name.toLowerCase())}>
            {/* <img src={item.image} alt={item.name} className="product-img" /> */}
            <h3>{item.name}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
